module.exports = __webpack_public_path__ + "static/media/IKMS06.75d553b1.jpg";